import { useEffect, useState } from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { iuteMonthly } from '../utils/iutepay';

/**
 * Whether IutePay finances this amount: the monthly payment, or null
 * (IutePay off, amount below IUTE's minimum, or IUTE unreachable).
 * Checkout offers IutePay only when there is one.
 */
export default function useIuteOffer(amount) {
  const { iutepay } = useSiteSettings();
  const value = Math.round(Number(amount)) || 0;
  const [monthly, setMonthly] = useState(null);

  useEffect(() => {
    if (!iutepay || value <= 0) { setMonthly(null); return undefined; }
    let active = true;
    const timer = setTimeout(() => {
      iuteMonthly({ apiBase: iutepay.apiBase, publicKey: iutepay.publicKey, amount: value })
        .then((result) => { if (active) setMonthly(result); });
    }, 300);
    return () => { active = false; clearTimeout(timer); };
  }, [iutepay, value]);

  return monthly;
}
